module.exports = __webpack_public_path__ + "media/images/recipes/tournedos-70f8facf40b9ca785de382ea2a9fe26f.pdf";